import { Modal } from "@smart/itops-sb-design-system-dom";

import { DropAction } from "../types";

export type MoveFieldConfirmationModalProps = {
  action: DropAction | undefined;
  onCancel: () => void;
  onConfirm: () => void;
};

export const MoveFieldConfirmationModal = ({
  action,
  onCancel,
  onConfirm,
}: MoveFieldConfirmationModalProps) => (
  <Modal
    open={!!action}
    onClose={onCancel}
    header={{
      icon: "regularFolder",
      text: "Move question with mapped field",
    }}
    footer={{
      buttons: [
        {
          text: "Cancel",
          variant: "secondarySubtle",
          onClick: onCancel,
        },
        {
          text: "Continue",
          variant: "primaryDefault",
          onClick: onConfirm,
        },
      ],
    }}
  >
    <p>
      The question has a mapped field incompatible with the destination
      location.
    </p>
    <p>
      Click &quot;Continue&quot; to move the question anyway without the mapped
      field.
    </p>
  </Modal>
);
